export default __webpack_public_path__ + "media/images/app-icon-abab3df1e715e01a679db17c807deb7a.svg";